import { render } from "./BannerPanden.vue?vue&type=template&id=ec6f415e&scoped=true"
import script from "./BannerPanden.vue?vue&type=script&lang=js"
export * from "./BannerPanden.vue?vue&type=script&lang=js"

import "./BannerPanden.vue?vue&type=style&index=0&id=ec6f415e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6f415e"]])

export default __exports__